/**
 * Created by akrio on 2018/3/23.
 */
import axios from "../utils/fetch";
import fetch from "axios";
/**
 * 实现tw扥估
 * @param  oauth 登录头
 */
export function loginTw({ oauth }) {
  return fetch.post("https://api.twitter.com/oauth/request_token", {
    headers: {
      OAuth: oauth,
    },
  });
}
// 发送全部
export function postAll() {
  return axios.post("posts/activate/all");
}
/**
 * 获取post列表
 * http://schedulepost.dev.apphi.com/api/docs/#!/posts/Post_list
 * @param post_time__gte 开始时间
 * @param post_time__lte 结束时间
 * @param offset 页码偏移
 * @param reverse 是否按 post_time 正序排列
 * @param media_type 过滤的类型 1,2,8 post 其他为story
 */
export function list({
  post_time__gte,
  post_time__lte,
  offset,
  limit,
  reverse,
  media_type,
}) {
  return axios.get("posts", {
    params: {
      post_time__gte,
      post_time__lte,
      offset,
      limit,
      reverse,
      media_type,
    },
  });
}

/**
 * 获取当前已发布post信息
 * @param offset
 */
export function postedList({ offset, limit }) {
  return axios.get("posts/history", { params: { offset, limit } });
}

/**
 * 添加post信息
 * @param form
 */
export function addPost({ form, publisherId }) {
  return axios.post("posts", form, {
    headers: {
      "X-Apphi-Request-Publisher-Id": publisherId,
    },
  });
}

/**
 * 修改post信息
 * @param form 修改的表单
 * @param publisherId 涉及到的publisher
 * @param id 修改的表单Id
 * @returns {AxiosPromise<any> | * | IDBRequest | Promise<void>}
 */
export function editPost({ form, publisherId, id }) {
  return axios.put(`posts/${id}`, form, {
    headers: {
      "X-Apphi-Request-Publisher-Id": publisherId,
    },
  });
}

/**
 * 删除post
 * @param ids
 */
export function delPost({ ids }) {
  return axios.delete("posts", { data: { ids } });
}

/**
 * 马上发布
 * @param ids
 */
export function postNow({ id, publisherId }) {
  return axios.post(
    `posts/${id}/instagram`,
    {},
    {
      headers: {
        "X-Apphi-Request-Publisher-Id": publisherId,
      },
      timeout: 90000,
    }
  );
}

/**
 * 从 Instagram 删除该 post
 * @param pk post id
 */
export function removePost({ pk }) {
  return axios.delete(`posts/${pk}/instagram`, pk);
}
/**
 * 获取验证的post信息
 * https://post-test.apphi.com/api/docs/#!/posts/Post_get_share_link 根据id获取链接
 * @param token url上的token
 * @returns {*}
 */
export function getPostBy({ token }) {
  return axios.get(`posts/${token}`, { ignoreToken: true });
}
/**
 * 审核信息
 * @param token url上的token
 * @param status 评审状态 2：接受，3：拒绝
 * @returns {*}
 */
export function approvePostBy({ token, status }) {
  return axios.patch(`posts/${token}`, { reviewing_status: status });
}
